import { getItem, getLocalizedPathFromLocalStorage } from '../helper/localstorage.helper';
import { Link, useLocation } from 'react-router-dom';
import { ImgFile } from './images/png/icons';
import { LOCALES } from '../../common/constants';
import { useLocalizedNavigation } from '../hooks/useLocalizedNavigation';
import { ChevronDownIcon, English, Swedish } from './images/svg/icons';
import { NavDropdown } from 'react-bootstrap';
import { languages } from '../constant/header.constant';
import { useTranslation } from 'react-i18next';

export function RegistrationHeader() {
    const { switchLanguageAndNavigate } = useLocalizedNavigation();
    const { t } = useTranslation();
    
    // Get language from URL query params (exact same pattern as main Header component)
    const lang = new URLSearchParams(useLocation().search).get('lang');

    // Language change function (exact same pattern as main Header component)
    const changeLanguage = (lng: string) => {
        switchLanguageAndNavigate(lng);
    };
    return (
        <div className="registration-header">
            <div className="registration-header-content">
                <div className="logo">
                    <Link to={getLocalizedPathFromLocalStorage({ get: (key: string) => getItem(key) ?? null }, { 'sv-se': '', 'en-us': '' })} reloadDocument>
                        <img src={ImgFile} alt="Invozio" />
                    </Link>
                </div>
                <NavDropdown
                    title={
                        <div className="nav-dropdown">
                            <span className="d-flex align-items-center">
                                <img src={lang === 'en-us' ? English : Swedish} alt="Language" />
                            </span>
                            <span>{lang === 'en-us' ? t('ENGLISH') : t('SWEDISH')}</span>
                            <img src={ChevronDownIcon} alt="Chevron" />
                        </div>
                    }
                    id="language-dropdown"
                    align="end"
                    className=""
                >
                    {languages.map((language) => (
                        <NavDropdown.Item key={language.code} href="#" className='bg-light border-0' onClick={() => changeLanguage(language.code)}>
                            <div className='d-flex align-items-center  py-2 pr-0 '>
                                {language.icon}
                                <span className='mx-2 gap-2'>{t(language.label)}</span>
                            </div>
                        </NavDropdown.Item>
                    ))}
                </NavDropdown>
            </div>
        </div>

    )
}
